import { isEmpty } from 'lodash'

const ls: ILocalStorage = {
  clear(): void {
    return localStorage.clear()
  },
  getItem(key: string, ifEmpty = ''): string {
    const value = localStorage.getItem(key)
    if (isEmpty(value)) {
      return ifEmpty
    }

    return value
  },
  key(index: number): string | null {
    return localStorage.key(index)
  },
  removeItem(key: string): void {
    return localStorage.removeItem(key)
  },
  setItem(key: string, value: string): void {
    return localStorage.setItem(key, value)
  },
}

export default ls

export interface ILocalStorage {
  clear(): void

  getItem(key: string, ifEmpty: string): string

  key(index: number): string | null

  removeItem(key: string): void

  setItem(key: string, value: string): void
}
